import { useState, useEffect } from "react";
import Common from "../../../helper/common";
import { Button } from "../../../components/ui/button";
import AdvanceTable from "../../../components/advanceTable";
import { AppInput, AppSelect } from "../../../components/appComponents";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { useQueryParams } from "../../../contexts/queryParamsContext";
import { TransactionLogStatusEnum } from "../../../constants/appConstant";

// import Utility from "../../../helper/utilityHelper";
const DiscountLogs = () => {
  const [apiresponse, setApiResponse] = useState({});
  let [from, setFrom] = useState(null);
  let [till, setTill] = useState(null);
  const [status, setStatus] = useState(null);
  const [byClub, setByClub] = useState(null);
  const { setId } = useQueryParams();
  const { params, setParams } = useQueryParams();
  
  const navigate = useNavigate();
  useEffect(() => {
    // getData() jis m pagination hoga...
    getData(1);
  }, []);

  useEffect(() => {
    // getData() jis m pagination hoga...
    getData(1);
  }, [from, till, status, byClub]);

  const resetFilters = () => {
    setFrom(null);
    setTill(null);
    setStatus(null);
    setByClub(null);
  };

  const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null
  ) => {
    if (from === "") from = null;
    if (till === "") till = null;

    const response = await Common.ApiService.getInstance().request(
      "GetBankDiscountList",
      {
        pageNumber: pageNumber,
        q: searchTerm,
        recordsToDisplay,
        status: status,
        fromdate: from,
        tilldate: till,
        isByClub: byClub,
      },
      "Post"
    );

    if (response?.data) {
      debugger;
      let obj = {
        ...response.data[0],
        data: response.data[0].data.map((item) => ({
          ...item,
          desc: item.desc ?? "-",
          pfr_transaction_amount: item.pfr_transaction_amount ?? "-",
          pfr_merchant_amount: item.pfr_merchant_amount ?? "-",
          promoCodeAmt: item.promoCodeAmt ?? "-",
          // attachment: item.attachment ?? "-",
          pfr_issuer_name: item.pfr_issuer_name ?? "-",
          isByClub: item.isByClub ? "Yes" : "No",
          createdOn: Common.Utility.ConvertTime(item.createdOn),
          // playername: item.palyerName ?? "-",
          bank: item.bank ?? "-",
          promocodePercent: item.promocodePercent ?? "-",

          // baqi h
          clubdiscountid: item.clubdiscountid ?? "-",
          status:
            Common.Utility.getKeyByValue(
              TransactionLogStatusEnum,
              item.status
            ) ?? "-",

          clubDiscountName: item.clubDiscountName ?? "-",
          bookingDate:item.bookingDate ? Common.moment(item.bookingDate).format("DD-MM-YYYY") : "-",
          bin_number:item.bin_number??"-",
          pfr_masked_pan:item.pfr_masked_pan ?? "-",
          totalDiscountAmount: (item.club_bearing_amount && item.bank_bearing_amount) 
            ? (item.club_bearing_amount + item.bank_bearing_amount).toFixed(2) 
            : '-',
          club_bearing_amount: item.club_bearing_amount 
            ? `${item.club_bearing_amount.toFixed(2)}` 
            : '-',
          bank_bearing_amount: item.bank_bearing_amount 
            ? `${item.bank_bearing_amount.toFixed(2)}` 
            : '-',

            clubpercentage: item.club_bearing_amount 
            ? `${((item.club_bearing_amount / ((item.club_bearing_amount + item.bank_bearing_amount))) * 100).toFixed(2)}%`  
            : '-',

            bankpercentage: item.bank_bearing_amount 
            ? `${((item.bank_bearing_amount / ((item.club_bearing_amount + item.bank_bearing_amount))) * 100).toFixed(2)}%`  
            : '-',

          // attachment:
          //   Common.Utility.getImagePath(item?.attachment?.path) ??
          //   "Recipt Image",
        })),
      };

      setApiResponse(obj);
    }
  };

  const columns = [
    { title: "Basket ID", type: "number", isVisible: true, key: "id" },
    {
      title: "Receipt",
      type: "image",
      isVisible: false,
      key: "attachment",
      // render: (_, record) => (
      //   <img
      //     src={Utility.getImagePath(record?.attachment?.path)}
      //     alt={record?.attachment?.title || "Receipt Image"}
      //     className="w-150 h-150 object-cover rounded-lg"
      //   />
      // ),
    },
    { title: "Booking Date", type: "text", isVisible: true, key: "bookingDate" },
    {
      title: "Player Name",
      type: "text",
      isVisible: true,
      key: "playerName",
    },

    {
      title: "Card Discount Name",
      type: "text",
      isVisible: true,
      key: "clubDiscountName",
    },
    
    {
      title: "Discount Amount",
      type: "number",
      isVisible: false,
      key: "pfr_discounted_amount",
    },

    {
      title: "Bank",
      type: "text",
      isVisible: true,
      key: "bank",
    },
    { title: "Bin Number", type: "text", isVisible: true, key: "bin_number" },
    { title: "Masked pan Number", type: "text", isVisible: true, key: "pfr_masked_pan" },


    { title: "By Club", type: "text", isVisible: true, key: "isByClub" },
    {
      title: "Status",
      type: "number",
      isVisible: true,
      key: "status",
    },
    {
      title: "Transaction Amount",
      type: "number",
      isVisible: true,
      key: "pfr_transaction_amount",
    },
    {
      title: "Merchant Amount",
      type: "number",
      isVisible: true,
      key: "pfr_merchant_amount",
    },
    {
      title: "Discount Amount",
      type: "number",
      isVisible: true,
      key: "promoCodeAmt",
    },
    {
      title: "Bank Share",
      type: "number",
      isVisible: true,
      key: "bank_bearing_amount",
    },
     {
      title: "%",
      type: "number",
      isVisible: true,
      key: "bankpercentage",
    },  
    {
      title: "Club Share",
      type: "number",
      isVisible: true,
      key: "club_bearing_amount",
    },
     {
      title: "%",
      type: "number",
      isVisible: true,
      key: "clubpercentage",
    },

    {
      title: "Add By",
      type: "text",
      isVisible: true,
      // key: "createdBy",

      key: "createdByName",
    },
    {
      title: "Add On",
      type: "text",
      isVisible: true,
      key: "createdOn",
    },
  ];

  const actions = [
    {
      type: "view",
     onClick: (val) => {
          if (val.bookingId) {
            setParams({
              ...params,
              bookingId: val.bookingId,
            });
            navigate(`/app/bookingDetails`);
          }
        },
    }
    // {
    //   type: "edit",
    //   onClick: (val) => {
    //     setId(val.id);
    //     navigate("/app/addbankdiscount");
    //   },
    // },
    // {
    //   type: "delete",
    //   onClick: (val) => _handleDelete(val),
    // },
  ];
  const selectedEnum = {
    Success: TransactionLogStatusEnum.Success,
    Failed: TransactionLogStatusEnum.Failed,
  };

  const _addBtn = () => (
    <Button
    // onClick={() => navigate("/app/addbankdiscount")}
    >
      <span className="text-xl mr-1">
        <Icon icon="icon-park-outline:plus" />
      </span>
      Add Bank Discount
    </Button>
  );
  // const _addUpdateTrigger = () => {
  //   <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
  //     <Icon icon="heroicons:pencil" className="h-4 w-4" />
  //   </Button>;
  // };

  const visibleColumns = [...columns.filter((c) => c.isVisible)];
  return (
    <>
      <div className="md:grid md:grid-cols-5 grid grid-cols-2 gap-x-2 ">
        <AppInput
          type={"date"}
          value={from}
          onChange={(e) => {
            const selectedstartDate = e;
            if (till && selectedstartDate > till) {
              Common.showToast(
                "From Date must be lesser than till Date",
                "Error",
                "info"
              );
              setFrom(null);
            } else {
              setFrom(selectedstartDate);
            }
          }}
          label="From"
          className="mb-3 col-span-1"
        />
        <AppInput
          type={"date"}
          value={till}
          onChange={(e) => {
            const selectedEndDate = e;
            if (selectedEndDate < from) {
              Common.showToast("End Date must be greater", "Error", "info");
              setTill(null);
            } else {
              setTill(selectedEndDate);
            }
          }}
          label="Till"
          className="mb-3 col-span-1"
        />

        <AppSelect
          value={status}
          onChange={setStatus}
          placeholder="Select Status Type"
          label="Status"
          data={[
            { id: null, name: "All" },
            ...Common.Utility.enumToArray(selectedEnum),
          ]}
          className="mb-3 col-span-1"
        />

        <AppSelect
          value={byClub}
          onChange={setByClub}
          label="By Club"
          data={[
            { id: null, name: "Select" },
            { id: true, name: "Yes" },
            { id: false, name: "No" },
          ]}
          className="mb-3 col-span-1"
        />

        <Button className="lg:mt-6 h-8 mb-5" onClick={resetFilters}>
          Reset Filters
        </Button>
      </div>

      {apiresponse?.data && (
        <AdvanceTable
          title={"Discount Logs"}
          columns={columns.filter((item) => item.isVisible)}
          data={apiresponse}
          getData={getData}
          // addButton={_addBtn}
          showPagination
          showAddButton
          actionButtons={actions}
          showExportoptions

          // updateTrigger={_addUpdateTrigger}
          // search={SearchTypeEnum.Server_Search}
          // searchInputClassName="custom-search-mobile "
        />
      )}
    </>
  );
};

export default DiscountLogs;
